export const LogoMark = ({ size = 30, dark = true }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
    >
        <rect width="32" height="32" rx="7" fill={dark ? "#09090B" : "#FAFAFA"} />
        <path
            d="M9.5 8h13v3.2h-9.8v3.4h8.4v3.2h-8.4v3.8h9.8v3.2H9.5V8z"
            fill={dark ? "#FAFAFA" : "#09090B"}
        />
        <rect x="12.7" y="14.6" width="8.6" height="3.2" fill="#2563EB" />
    </svg>
);

export const Logo = ({ inverted = false }) => (
    <span className="inline-flex items-center gap-2.5">
        <LogoMark dark={!inverted} />
        <span
            className={`font-semibold tracking-tight text-lg leading-none ${
                inverted ? "text-zinc-50" : "text-zinc-950"
            }`}
            style={{ fontFamily: "Outfit, sans-serif" }}
        >
            Emira<span className="text-blue-600"> Digital</span>
        </span>
    </span>
);
